import { useTranslation } from 'react-i18next';
import { FaDiscord, FaTelegram, FaXTwitter } from 'react-icons/fa6';
import { TfiWorld } from 'react-icons/tfi';
///////////////////////////////////////////////////////////
import { telegramWebApp } from '@/main';
import { Button } from '@/app/shared/components';

export const PlayOnMobile: React.FC = () => {
	/*********************
	// #region Hooks
	**********************/
	const { t } = useTranslation();

	/*********************
	// #region Functions
	**********************/
	function openLink(link: string) {
		telegramWebApp.openLink(link);
	}

	function openTelegramLink(link: string) {
		telegramWebApp.openTelegramLink(link);
	}
	/*********************
	// #region Template
	**********************/
	return (
		<div
			style={{
				backgroundImage: `url('${process.env.VITE_PLAY_ON_MOBILE_BG}')`,
			}}
			className={`flex flex-col w-full min-h-svh justify-center bg-center bg-cover bg-no-repeat`}
		>
			<div className="flex flex-col w-full items-center mb-10 space-y-5">
				<div className="flex">
					<img
						src={process.env.VITE_PLAY_ON_MOBILE_IMAGE}
						className="drop-shadow-lg px-6"
					/>
				</div>
				<p className="text-2xl font-bold">{t('playOnMobile.title')}</p>
				<div
					style={{
						backgroundImage: `url('${process.env.VITE_QR_IMAGE}')`,
					}}
					className={`w-56 h-56 rounded-2xl bg-white bg-cover bg-center bg-no-repeat`}
				></div>
				<p className="text-xl font-semibold">
					{process.env.VITE_APP_BOT_NAME!}
				</p>
				<div className="w-full px-8 space-y-2">
					<div className="flex space-x-2">
						<Button
							type="button"
							variant="inviteFriends"
							onClick={() =>
								openTelegramLink(process.env.VITE_TELEGRAM_URL!)
							}
							className="text-md flex rounded-lg flex-1 shadow-lg py-6 disabled:opacity-75 leadering-none"
						>
							<FaTelegram size={18} /> Telegram
						</Button>
						<Button
							type="button"
							variant="inviteFriends"
							onClick={() =>
								openLink(process.env.VITE_TWITTER_URL!)
							}
							className="text-md flex rounded-lg flex-1 shadow-lg py-6 disabled:opacity-75 leadering-none"
						>
							<FaXTwitter size={18} /> Twitter
						</Button>
					</div>
					<div className="flex space-x-2">
						<Button
							type="button"
							variant="inviteFriends"
							onClick={() =>
								openLink(process.env.VITE_DISCORD_URL!)
							}
							className="text-md flex rounded-lg flex-1 shadow-lg py-6 disabled:opacity-75 leadering-none"
						>
							<FaDiscord size={18} /> Discord
						</Button>
						<Button
							type="button"
							variant="inviteFriends"
							onClick={() =>
								openLink(process.env.VITE_WEBSITE_URL!)
							}
							className="text-md flex rounded-lg flex-1 shadow-lg py-6 disabled:opacity-75 leadering-none"
						>
							<TfiWorld size={18} /> Web
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};
